import { Component, Input } from '@angular/core';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { StorageConstants } from '../../../constants/storage.constants';
import { MessageService } from '../../../services/message.service';
import { NameService } from '../../../services/name.service';

@Component({
  selector: 'player-profile',
  templateUrl: './player-profile.component.html',
  styleUrls: ['./player-profile.component.scss']
})
export class PlayerProfileComponent {
  private playerName: string;
  private initials: string;
  showImage = false;
  faPen = faPen;

  constructor(private nameService: NameService, private messageService: MessageService) {
    this.playerName = localStorage.getItem(StorageConstants.PlayerName);
    this.initials = this.nameService.getInitials(this.playerName).toUpperCase().substr(0, 2);
    this.nameService.nameChangeReceived$.subscribe(
      name => {
        this.playerName = name;
        this.initials = this.nameService.getInitials(this.playerName).toUpperCase().substr(0, 2);
      }
    );
  }

  async onSubmit(newName: string) {
    if (this.nameService.validateName(newName)) {
      try {
        await this.nameService.saveName(newName);
      }
      catch {
        this.messageService.showError("Er is iets misgegaan tijdens het opslaan van uw naam, herlaad de pagina en probeer het opnieuw");
      }
    }
    else {
      this.messageService.showWarning(this.nameService.getNameErrors(newName));
      this.playerName = localStorage.getItem(StorageConstants.PlayerName);
    }
  }
}
